import type { BudgetDocument, BudgetSnapshot } from '../types'
import { deepClone } from '../utils'

const SCHEMA_VERSION = 1 as const

/**
 * Serialize / deserialize budget documents for future storage, API, mobile, PDF.
 * No filesystem or network I/O here.
 */
export class BudgetSerializer {
  toSnapshot(document: BudgetDocument): BudgetSnapshot {
    return {
      schemaVersion: SCHEMA_VERSION,
      savedAt: new Date().toISOString(),
      document: deepClone(document),
    }
  }

  toJSON(document: BudgetDocument): string {
    return JSON.stringify(this.toSnapshot(document))
  }

  fromJSON(raw: string): BudgetDocument {
    const parsed = JSON.parse(raw) as unknown
    return this.fromSnapshot(parsed)
  }

  fromSnapshot(raw: unknown): BudgetDocument {
    if (!raw || typeof raw !== 'object') {
      throw new Error('BUDGET_SERIALIZER_INVALID: payload must be an object')
    }
    const snapshot = raw as Partial<BudgetSnapshot>
    if (snapshot.schemaVersion !== SCHEMA_VERSION) {
      throw new Error(
        `BUDGET_SERIALIZER_UNSUPPORTED: schemaVersion=${String(snapshot.schemaVersion)}`,
      )
    }
    if (!snapshot.document || typeof snapshot.document !== 'object') {
      throw new Error('BUDGET_SERIALIZER_INVALID: missing document')
    }
    return deepClone(snapshot.document)
  }
}

export const budgetSerializer = new BudgetSerializer()
